import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ChevronUpIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M1.437,12.25 C1.47006852,12.25 3.49606852,10.1566667 7.515,5.97 L14.023,12.274 L15.414,10.837 L7.47,3.141 L8.8817842e-16,10.86 C0.924931478,11.7866667 1.40393148,12.25 1.437,12.25 Z"
        data-testid="icon-chevronUp"
        fill={customColour}
        className={styles[className]}
      />
    </Icon>
  )
}
